import { useSelector } from "react-redux";

import { useGetAssignedReferenceRequestsQuery } from "../store/Company/companyApiSlice";

/* Who the Payment References Hub is for. */

/* Whether the response actually carries assigned requests. The 200 body is
   `{data: [...], stats: {...}}`; an older shape returned the bare array, so
   both are accepted rather than assuming one. */
export const hasAssignedReferences = (response) => {
  if (!response) return false;
  const rows = Array.isArray(response) ? response : response.data;
  return Array.isArray(rows) && rows.length > 0;
};

export const PAYMENT_REF_ENABLED = () => process.env.REACT_APP_PAYMENT_REF === "true";

export default function usePaymentReferenceAccess() {
  const token = useSelector((state) => state.auth?.token);
  const enabled = PAYMENT_REF_ENABLED();

  const { data, isLoading, isFetching } = useGetAssignedReferenceRequestsQuery(token, {
    skip: !enabled || !token,
  });

  /* Hidden while the answer is still unknown. Showing it first and removing it
     on the 404 would flicker an item the account may never be allowed to see,
     which reads worse than it appearing a moment late. */
  return {
    canSeePaymentReferences: enabled && hasAssignedReferences(data),
    isResolving: enabled && Boolean(token) && (isLoading || isFetching),
  };
}
